import type { IconData } from '@stacksjs/iconify-core'

export const wifiSignal0: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M237.778 480h36.444L504 151.842V124.4l-.215-.15a432.02 432.02 0 0 0-495.57 0L8 124.4v27.438ZM256 78.128a397.87 397.87 0 0 1 216.144 63.419L256 450.232L39.856 141.547A397.87 397.87 0 0 1 256 78.128\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default wifiSignal0
